import { useLocation } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import useCyclesActions from 'modules/payroll_bundle/hooks/useCyclesActions'
import { PayrollPhase, PayrollStatus } from 'modules/payroll_bundle/lib/enums'
import { useGetSelectedTab } from 'modules/payroll_bundle/lib/useGetSelectedTab'

interface Props {
  status: PayrollStatus
  policyId: string
  periodId: string
  isVisible: boolean
}

const Footer = ({ status, policyId, periodId, isVisible }: Props) => {
  const { navigation } = useNavigation()

  const { pathname: path } = useLocation()

  const currentSelectedTab = useGetSelectedTab({
    path,
    policyId,
    policyPeriodId: periodId,
    navigation,
  })

  const { primary, secondary } = useCyclesActions({
    status,
    policyId,
    periodId,
  })

  const defaultActions = () => {
    return { transactionalActions: { primary, secondary } }
  }

  const emptyActions = () => {
    return { transactionalActions: { primary: null } }
  }

  if (!isVisible) return {}

  switch (currentSelectedTab) {
    case PayrollPhase.SUPPLEMENTS_DEFINITION:
      return defaultActions()
    case PayrollPhase.PAYROLL_CALCULATION:
    case PayrollPhase.PAYMENT:
      return emptyActions()
  }

  return defaultActions()
}

export default Footer
